// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectProduct_custom-select__cMzMZ","header-select":"SelectProduct_header-select__BMm6t"};